import { Tag } from "./Badge";
import { cn } from "@/lib/utils";
import { LucideIcon } from "lucide-react";

interface DataCardProps {
  tag: string;
  stat: string;
  statLabel: string;
  description: string;
  bullets: string[];
  className?: string;
  icon?: LucideIcon;
}

export const DataCard = ({ tag, stat, statLabel, description, bullets, className, icon: Icon }: DataCardProps) => {
  return (
    <div className={cn("data-card group hover:shadow-md transition-shadow duration-300", className)}>
      <div className="flex items-start justify-between gap-2">
        <Tag>{tag}</Tag>
        {Icon && (
          <div className="w-8 h-8 rounded-lg bg-primary/5 flex items-center justify-center shrink-0">
            <Icon className="w-4 h-4 text-primary" />
          </div>
        )}
      </div>
      
      <div className="text-xl sm:text-2xl md:text-[28px] font-display font-bold tracking-tight mt-2 mb-1 text-foreground">
        {stat}
        <span className="text-[10px] sm:text-xs font-sans font-medium text-muted-foreground ml-1.5">{statLabel}</span>
      </div>
      
      <p className="text-[11px] sm:text-xs text-muted-foreground leading-relaxed mb-3">
        {description}
      </p>
      
      <ul className="list-none space-y-1.5">
        {bullets.map((bullet, i) => (
          <li key={i} className="flex items-start gap-2 text-[11px] sm:text-xs text-muted-foreground">
            <span className="w-1 h-1 rounded-full bg-primary mt-1.5 shrink-0" />
            {bullet}
          </li>
        ))}
      </ul>
    </div>
  );
};

interface SimpleCardProps {
  title: string;
  children: React.ReactNode;
  className?: string;
}

export const SimpleCard = ({ title, children, className }: SimpleCardProps) => {
  return (
    <div className={cn("data-card hover:shadow-md transition-shadow duration-300", className)}>
      <h3 className="font-display text-sm sm:text-base font-semibold mb-3 text-foreground">{title}</h3>
      {children}
    </div>
  );
};
